import React from "react";
import { capitalize } from "../../utils/textFunctions";

const Identifier = ({ data, summary: isSummary }) => {
  if (isSummary) {
    return null;
  }

  if (data.length === 0) {
    return (
      <section>
        <h3>Identifiers</h3>
        <div>
          <h4>Empty</h4>
        </div>
      </section>
    );
  }

  return (
    <section>
      <h3>Identifiers</h3>
      <div>
        <div>
          <h4>System</h4>
        </div>
        <div>
          <h4>Value</h4>
        </div>
        <div>
          <h4>Use</h4>
        </div>
      </div>

      {data.map((id, index) => {
        return (
          <div key={index}>
            <div>
              <div>{id.system}</div>
            </div>
            <div>
              <div>{id.value}</div>
            </div>
            <div>
              <div>{capitalize(id.use)}</div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default Identifier;
